module.exports = __webpack_public_path__ + "/login_ui/img/al-ae05a58c7152fe3eac8cc520a558c763.svg";